import { render, staticRenderFns } from "./PaymentNotAvailableView.vue?vue&type=template&id=bc70f616&scoped=true&"
import script from "./PaymentNotAvailableView.vue?vue&type=script&lang=js&"
export * from "./PaymentNotAvailableView.vue?vue&type=script&lang=js&"
import style0 from "./PaymentNotAvailableView.vue?vue&type=style&index=0&id=bc70f616&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc70f616",
  null
  
)

export default component.exports